export enum BUTTON_LEVEL {
    PRIMARY = 'primary',
    SECONDARY = 'secondary'
}

export enum BUTTON_SIZE {
    DEFAULT = 'default',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large'
}
